var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9831 9.7582C14.9831 12.9799 12.3714 15.5915 9.14974 15.5915C5.92808 15.5915 3.31641 12.9799 3.31641 9.7582C3.31641 6.53654 5.92808 3.92487 9.14974 3.92487C12.3714 3.92487 14.9831 6.53654 14.9831 9.7582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7697 2.79286L9.14974 0.598694L2.52974 2.79286C2.03097 2.9582 1.59698 3.2765 1.28941 3.70255C0.981841 4.12859 0.816337 4.64072 0.816406 5.16618V10.5912C0.816406 16.8612 8.48308 20.3237 8.81141 20.4678L9.10641 20.5987L9.41308 20.497C9.74308 20.387 17.4831 17.7387 17.4831 10.5912V5.16618C17.4831 4.64072 17.3176 4.12859 17.0101 3.70255C16.7025 3.2765 16.2685 2.9582 15.7697 2.79286ZM9.51974 12.2487C9.37406 12.3953 9.2007 12.5116 9.00972 12.5907C8.81875 12.6698 8.61396 12.7102 8.40724 12.7095H8.37974C8.16882 12.7063 7.96074 12.6603 7.76809 12.5744C7.57544 12.4884 7.40222 12.3643 7.25891 12.2095L5.33724 10.2095L6.53974 9.05784L8.40974 11.0078L12.7272 6.69035L13.9056 7.86868L9.51974 12.2487Z",
    fill: "#0FB3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.48cb36c78705b5b7f1a9ef53df850aad.svg";
export { ForwardRef as ReactComponent };